import { progressionContext } from "../progression/context.js";
export function automationCommand(automation, enabled) {
    return {
        id: `automation:${automation.id}:${enabled ? "enable" : "disable"}`,
        execute: (transaction) => {
            if (!transaction.isScopeActive(automation.scope))
                transaction.reject({
                    code: "disabled",
                    actionId: automation.id,
                    reasonKey: "scope-inactive",
                });
            if (enabled && !automation.unlocked(progressionContext(transaction))) {
                transaction.reject({ code: "locked", prerequisiteIds: [automation.id] });
            }
            transaction.setAutomation(automation.id, {
                enabled,
                nextRunMs: transaction.getAutomation(automation.id)?.nextRunMs ??
                    transaction.gameTimeMs() + automation.cadenceMs,
            });
        },
    };
}
export function runAutomation(transaction, definitions, boundaryMs) {
    for (const automation of [...definitions].sort(compareAutomation)) {
        let state = transaction.getAutomation(automation.id) ?? {
            enabled: automation.initiallyEnabled,
            nextRunMs: automation.cadenceMs,
        };
        while (state.nextRunMs <= boundaryMs) {
            const context = progressionContext(transaction);
            if (transaction.isScopeActive(automation.scope) &&
                state.enabled &&
                automation.unlocked(context) &&
                automation.condition(context)) {
                automation.action(context).execute(transaction);
            }
            state = { ...state, nextRunMs: state.nextRunMs + automation.cadenceMs };
        }
        transaction.setAutomation(automation.id, state);
    }
}
function compareAutomation(left, right) {
    if (left.priority !== right.priority)
        return left.priority - right.priority;
    return left.id < right.id ? -1 : left.id > right.id ? 1 : 0;
}
//# sourceMappingURL=scheduler.js.map